// Mismo criterio que cajaChica/permisos.js — replicado tal cual para Caja Instalación.
export const esSubRolContable = (subRol) => String(subRol || "").toLowerCase().startsWith("cont");

export const esRolAdminGerenteContable = (user) =>
  user?.role === "admin" || user?.role === "gerente" || esSubRolContable(user?.sub_rol);
